window.dataLayer = window.dataLayer || {};
window.dataLayerHelpers = window.dataLayerHelpers || {};

// Clear the previous ecommerce object.
window.dataLayerHelpers.clearEcommerObject = function() {
    dataLayer.push({ ecommerce: null });  
}

/*
 * Updates datalayer when products are added to or removed from the cart
 * This function is called by the several angular controllers
 */

window.dataLayerHelpers.updateCart = function(data) {
    window.dataLayerHelpers.clearEcommerObject();
    if (data && data.length) {
        data.forEach(function(value) {
            dataLayer.push(value);
        });
    }
    return true;
}

/*
 * Updates datalayer when a list of products is shown
 * This function is called by the several angular controllers
 */

window.dataLayerHelpers.updateProductList = function(products, event) {
    if (products && products.length) {
        var data = analyticsTemplates.productImpression;

        // add products object
        data.ecommerce.impressions = products;

        // add events object
        if (event) {
            $.extend(data, event);
        }

        dataLayer.push(data);
    }
    return true;
}

/*
 * Collects the datalayer for products in a list which are not loaded through angular
 * A list is a html element with a [data-aid] attribute
 * Collected data is send to the udpateProductList helper
 * This is a self invoking function
 */

window.dataLayerHelpers.collectProductImpressions = (function(self) {
    const impressionDataAttr = 'data-analytics-product-impression';
    const parentAttr = 'data-aid';
    const productSelector = '['+impressionDataAttr+']';
    const parentSelector = '['+parentAttr+']';

    // Find all elements with the productSelector
    $(parentSelector).each(function(index, parent) {
        var productsData = [];

        $(parent).find(productSelector).each(function(index, el) {
            let productImpressionData = $(el).attr(impressionDataAttr);

            try {
                let product = JSON.parse(productImpressionData);
                product.position = index+1;
                product.list = $(parent).attr(parentAttr);
                productsData.push(product);
            } catch(e) {
                // silent error
            }
        });

        if (productsData.length) {
            self.updateProductList(productsData);
        }
    });
})(window.dataLayerHelpers);

/*
 * Updates datalayer when a product is clicked
 * This function is called by adding an onclick event to the clicked element
 * E.g. <a href="#" onclick="window.dataLayerHelpers.updateProductClick(this)">Link</a>
 */

window.dataLayerHelpers.updateProductClick = function(el) {
    window.dataLayerHelpers.clearEcommerObject();
    
    const dataAttr = 'data-analytics-product-click';
    const parentAttr = 'data-aid';
    const productSelector = '['+dataAttr+']';
    const parentSelector = '['+parentAttr+']';

    // Find parent
    const $product = $(el).closest(productSelector);

    // Return when product is not a child of an element with [data-aid] attribute
    if (!$product.length) return;

    try {
        let data = $product.attr(dataAttr);
        data = JSON.parse(data);

        // Store the parent element
        const $parent = $product.closest(parentSelector);

        // Calculate position of the clicked element
        // compared to it's siblings within the parentSelector
        const index = $parent.find(productSelector).index($product);
        data.position = index + 1;

        // Populate template with data
        const template = analyticsTemplates.productClick;
        template.ecommerce.click.products.push(data);
        template.ecommerce.click.actionField.list = $(el).attr(parentAttr) || $parent.attr(parentAttr);

        // Push
        dataLayer.push(template);
    } catch(e) {
        // silent error
    }
};

/* TODO: if this is the acceptable solution for data-analytics, refactor to use updateProductClick
 * Updates datalayer when a product detail link of image is clicked
 * This function is called by adding an onclick event to the clicked element
 * E.g. <a href="#" onclick="window.dataLayerHelpers.productDetailClick(this)">Link</a>
 */

window.dataLayerHelpers.productDetailClick = function(el) {
    window.dataLayerHelpers.clearEcommerObject();
    
    // productDetail click also fires updateProductClick event
    window.dataLayerHelpers.updateProductClick(el)
    
    const dataAttr = 'data-analytics-product-click';
    const parentAttr = 'data-aid';
    const productSelector = '['+dataAttr+']';
    const parentSelector = '['+parentAttr+']';

    // Find parent
    const $product = $(el).closest(productSelector);

    // Return when product is not a child of an element with [data-aid] attribute
    if (!$product.length) return;

    try {
        let data = $product.attr(dataAttr);
        data = JSON.parse(data);

        // Store the parent element
        const $parent = $product.closest(parentSelector);

        // Calculate position of the clicked element
        // compared to it's siblings within the parentSelector
        const index = $parent.find(productSelector).index($product);
        data.position = index + 1;

        // Populate template with data
        const template = analyticsTemplates.productDetailClick;
        template.ecommerce.click.products.push(data);
        template.ecommerce.click.actionField.list = $(el).attr(parentAttr) || $parent.attr(parentAttr);
     
        // Push
        dataLayer.push(template);
    } catch(e) {
        // silent error
    }
};

/*
 * Updates datalayer when an order is completed
 */

window.dataLayerHelpers.completeOrder = function(el) {
    window.dataLayerHelpers.clearEcommerObject();

    var dataAttrModel = 'data-complete-order-datalayer-model',
    dataAttrEvent = 'data-complete-order-datalayer-event',
    dataModel = el.getAttribute(dataAttrModel),
    dataEvent = el.getAttribute(dataAttrEvent);

    if (dataModel) {
        dataModel = JSON.parse(dataModel);
        dataEvent = JSON.parse(dataEvent);

        var dataCombined = $.extend({}, dataEvent, dataModel);

        dataLayer.push(dataCombined);
    }
}
